__turbopack_context__.v({
  "active": "style-module-scss-module__3o1EAa__active",
  "bar": "style-module-scss-module__3o1EAa__bar",
  "bar-container": "style-module-scss-module__3o1EAa__bar-container",
  "component": "style-module-scss-module__3o1EAa__component",
  "hide-header": "style-module-scss-module__3o1EAa__hide-header",
  "join-us-ready-button": "style-module-scss-module__3o1EAa__join-us-ready-button",
  "layout-container": "style-module-scss-module__3o1EAa__layout-container",
  "menu": "style-module-scss-module__3o1EAa__menu",
  "menu-item": "style-module-scss-module__3o1EAa__menu-item",
  "navigation": "style-module-scss-module__3o1EAa__navigation",
  "panel": "style-module-scss-module__3o1EAa__panel",
  "search-icon": "style-module-scss-module__3o1EAa__search-icon",
  "x": "style-module-scss-module__3o1EAa__x",
});
